import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import  { connect } from 'react-redux';
//actions
import tracker from 'actions/tracking'; //Google analytics
import SeriesActionCreator from "actions/SeriesActionCreator";
import SettingsActionCreator from "actions/SettingsActionCreator";
import ReactHint from 'react-hint';


//components
import MenuBar from 'components/headers/MenuBar';
import PrintHeader from 'components/headers/PrintHeader';
import PrintFooter from 'components/footers/PrintFooter';
import SeriesSummary from 'components/series/SeriesSummary';
import SalesRevenueGoal from 'components/series/goalCards/SalesRevenueGoal';
import TicketQuantitySoldGoal from 'components/series/goalCards/TicketQuantitySoldGoal';
import SeriesModal from 'components/series/modals/SeriesModal';
import TabbedGraphContainer from 'components/series/tabbedGraphs/TabbedGraphContainer';
import TBContainer from 'components/ticketBreakdown/TBContainer';
import SeriesComparisonChart from 'components/series/seriesComparison/SeriesComparisonChart';
// import LandscapeMessage from 'components/lib/messages/LandscapeMessage';
//utils
import Constants from 'utils/Constants';
import { DateFormatter } from 'utils/DateFormatter';
import 'utils/utils';
//styles
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import theme from 'themes/theme';
import styles from 'styles/components/series/SeriesDashboardContainer.css';

let MOBILE_SCREEN_SIZE = 768;
let IS_MOBILE = (/iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(navigator.userAgent.toLowerCase()));
let IS_TABLET = (/ipad|android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i.test(navigator.userAgent.toLowerCase()));
let IS_IOS_10 = (/os\s10/i.test(navigator.userAgent.toLowerCase())) &&
  (/ipad/i.test(navigator.userAgent.toLowerCase()));

class SeriesDashboardContainer extends Component {
  static childContextTypes = { media: PropTypes.object }
  static isSmall() {
    let windowWidth = window.innerWidth || window.clientWidth || window.clientWidth;
    return IS_MOBILE || windowWidth < MOBILE_SCREEN_SIZE;
  }
  static isMedium() {
    let hasTabletWidth = window.matchMedia("(min-width: 768px)").matches &&
      window.matchMedia("(max-width: 991px)").matches;
    return IS_TABLET || hasTabletWidth;
  }
  static isMobileLandscape() {
      return IS_MOBILE && window.matchMedia("(orientation: landscape)").matches;
  }
  static isTabletLandscape() {
    return IS_TABLET && window.matchMedia("(orientation: landscape)").matches;
  }
  static isMonitor() {
    return window.matchMedia("(min-width: 1400px)").matches;
  }
  constructor(props) {
    super(props);
    this.state = {
      chartSize: {},
      comparisonChartSize: {},
      errorMessage: null,
      errorBucketKey: null,
      productionId: null,
      selectedSeries2: null,
      selectedSeries3: null,
      seriesComparisonData: null,
      showComparisonChart: false,
      showRefreshMessage: false,
	    tooltipIsActive: true,
      feeInclusion: this.props.feeInclusion,
      graphSettings: {
        controlledDnDTableDate: null,
        controlledEndDate: null,
        controlledStartDate: null,
        initialStartDate: null,
        initialEndDate: null,
        hasAnnex: false,
        hasSalesData: false,
        hasTicketData: false,
        minDate: null,
        maxDate: null,
        selectedUnit: Constants.unit.day
      },
      media: {
	      isIOS10: IS_IOS_10,
        isIOSChrome: !!navigator.userAgent.match('CriOS'),
        isMedium: false,
        isMobile: IS_MOBILE,
        isMobileLandscape: false,
        isMonitor: false,
        isSmall: false,
        isTablet: IS_TABLET,
        isTabletLandscape: false,
        isTouchDevice: IS_MOBILE || IS_TABLET || ('ontouchstart' in window || navigator.msMaxTouchPoints)
      }
    };
    this.toggleSeriesComparisonChart = this.toggleSeriesComparisonChart.bind(this);
    this.getReportPeriod = this.getReportPeriod.bind(this);
    this.getSelectedUnit = this.getSelectedUnit.bind(this);
    this.handleSeriesCompare = this.handleSeriesCompare.bind(this);
    this.resetSeriesCompareField = this.resetSeriesCompareField.bind(this);
    this.changeSeries2 = this.changeSeries2.bind(this);
    this.changeSeries3 = this.changeSeries3.bind(this);
    this.clearError = this.clearError.bind(this);
    this.handleDnDTableAdd = this.handleDnDTableAdd.bind(this);
    this.handleDnDTableDelete = this.handleDnDTableDelete.bind(this);
    this.handleDnDTableUpdate = this.handleDnDTableUpdate.bind(this);
    this.handleSeriesChange = this.handleSeriesChange.bind(this);
    this.handleSubmitRevenueGoal = this.handleSubmitRevenueGoal.bind(this);
    this.handleSubmitTicketQuantityGoal = this.handleSubmitTicketQuantityGoal.bind(this);
    this.handleTabChanged = this.handleTabChanged.bind(this);
    this.updateGraphSettings = this.updateGraphSettings.bind(this);
    this.setDateRange = this.setDateRange.bind(this);
    this.setControlledDates = this.setControlledDates.bind(this);
    this.setControlledDnDDate = this.setControlledDnDDate.bind(this);
    this.getChartSize = this.getChartSize.bind(this);
    this.toggleFees = this.toggleFees.bind(this);
  }

  componentWillMount() {
    SeriesActionCreator.loadPendoData();
    this.props.getProductionsList();
	  SettingsActionCreator.getProductionPreferences().then(()=>{
		  this.setState({ defaultProductionPreferenceLoaded: true });
	  });

	  SettingsActionCreator.getTabPreferences().then((tab)=>{
		  if(tab) {
			  this.setState({selectedTabId: tab});
		  } else {
			  this.setState({selectedTabId: 0});
		  }
	  }, error => {
		  this.setState({selectedTabId: 0});
	  });
    // media...
    window.addEventListener("resize", () => {
      this.getChartSize
      this.windowResize.bind(this)
    });
    window.addEventListener("orientationchange", () => {
      this.getChartSize
      this.windowResize.bind(this)
    });
    this.windowResize();
  }

  componentDidMount(){
    this.getChartSize();
  }

  componentWillReceiveProps(nProps) {
	  let _this = this;
	  if (nProps.productionId &&
      !Object.deepEquals(nProps.productionId, this.state.productionId)) {

  		  if (!this.state.productionId) {
  			  this.setState({ firstTimeLoad:true });
  		  }
  		  this.setState({
          productionId: nProps.productionId
        }, () => {
          SeriesActionCreator.getSeriesComparisonData({
              productionIds: [Number(this.state.productionId)],
              unit: null }, this.state.feeInclusion )
            .then((data) => {
              this.setState({
                seriesComparisonData: data
              })
            })
  			  SeriesActionCreator.getProductionSummary(nProps.productionId, this.state.feeInclusion)
            .then((summary)=>{
  				    //log the series fetch event when series is first selected and everytime it is changed
  				    tracker.logEvent(summary.userId, summary.clientId, 'fetch', 'series',
                'summary', parseInt(nProps.productionId,10));
  				    //we need to track first tab that is loaded.
    				  if(_this.state.firstTimeLoad) {
    					  if(_this.state.selectedTabId === 1) {
    						  tracker.logEvent(summary.userId,summary.clientId,'toggle','ticketBreakDown',
                    'ticketBreakDown',parseInt(_this.state.selectedTabId,10));
    					  } else {
    						  tracker.logEvent(summary.userId,summary.clientId,'toggle','salesRevenue',
                    'salesRevenue',parseInt(_this.state.selectedTabId,10));
    					  }
    					  _this.setState({ firstTimeLoad: false });
    				  }
  			  });
          if(_this.state.firstTimeLoad) {
            this.props.getSeriesTicketInfo(nProps.productionId, this.state.feeInclusion);
          }
		  } );
	  }

    // sets graphSettings...
    let { graphSettings } = this.state;
    if (nProps.summary &&
      !Object.deepEquals(nProps.summary, this.props.summary)) {
      // console.log("SETTINGMINDATE!!!!!!!!!!!!", nProps.summary.dateInfo);
      this.updateGraphSettings({minDate: new Date(nProps.summary.dateInfo.firstTransactionDate)
      });
    }
    if (nProps.salesRevenueByDayData &&
      !this.state.graphSettings.hasSalesData &&
      !Object.deepEquals(nProps.salesRevenueByDayData, this.props.salesRevenueByDayData)) {
      this.updateGraphSettings({hasSalesData: true});
    }
    if (nProps.ticketSalesByDayData &&
      !!this.state.graphSettings.hasTicketData &&
      !Object.deepEquals(nProps.ticketSalesByDayData, this.props.ticketSalesByDayData)) {
      this.updateGraphSettings({ hasTicketData: true });
    }
    if (nProps.feeInclusion) {
      this.setState({
        feeInclusion: nProps.feeInclusion
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize",this.windowResize.bind(this));
    window.removeEventListener("orientationchange",this.windowResize.bind(this));
    window.removeEventListener("resize",this.getChartSize);
    window.removeEventListener("orientationchange",this.getChartSize);
  }

  changeSeries2(series) {
    this.setState({
      selectedSeries2: series
      //Callback for automatic refresh -- REMOVE IF USING COMPARE BUTTON
    }, () => {
      this.handleSeriesCompare();
    });
  }

  changeSeries3(series) {
    this.setState({
      selectedSeries3: series
      //Callback for automatic refresh -- REMOVE IF USING COMPARE BUTTON
    }, () => {
      this.handleSeriesCompare();
    });
  }

  clearError(messageOnly) {
    if (messageOnly) this.setState({ errorMessage: null });
    else this.setState({ errorMessage: null, errorBucketKey: null });
  }

	getChartSize = () => {
		let rect = this.refs.mainWrapper.getBoundingClientRect();
		this.setState({
			chartSize: {width: rect.width * 0.70, height: rect.height * 0.80 },
			comparisonChartSize: {width: rect.width, height: rect.height }
		});
	}

	getChildContext() {
    return { media: this.state.media };
  }

  getReportPeriod() {
    return {
      firstDay: this.state.graphSettings.controlledStartDate,
      lastDay: this.state.graphSettings.controlledEndDate
    };
	}

	getSelectedUnit() {
    let printUnit = 'Daily';
    switch (this.state.graphSettings.selectedUnit) {
      case Constants.unit.week:
        printUnit = "Weekly";
        break;
      case Constants.unit.month:
        printUnit = "Monthly";
        break;
      default: printUnit = 'Daily';
    }
    return printUnit;
  }

  handleRequest = (date, firstDataDate) => {
    let { minDate } = this.state.graphSettings;
    // by default get 1 year prior data
    let newStartDateForData = DateFormatter.getLastYearDateFrom(firstDataDate);
    // if the request date is before this date then get the data till that date
    if(DateFormatter.isBefore(date, newStartDateForData)) {
    	newStartDateForData = date;
    }
    //if first transaction date is after that date then get data till first transaction date
    if( !DateFormatter.isBefore(minDate, newStartDateForData)) newStartDateForData = minDate;

    let formattedStartDate = DateFormatter.formatDate(newStartDateForData, DateFormatter.SERVER_API);
    let formattedEndDate = DateFormatter.formatDate(DateFormatter.getDayBefore(firstDataDate),
      DateFormatter.SERVER_API);
    this.setState({graphSettings: {
      ...this.state.graphSettings,
      hasAnnex: true,
      controlledStartDate: date
    }}, () => {
        SeriesActionCreator.getSeriesRevenueDataForDateRange(this.props.summary.productionId,
          formattedStartDate , formattedEndDate)
        SeriesActionCreator.getTicketBreakdownForDateRange(this.props.summary.productionId,
          formattedStartDate , formattedEndDate);
    });
  }

  handleSeriesCompare() {
    if(!this.state.selectedSeries2 && !this.state.selectedSeries3) {
      SeriesActionCreator.getSeriesComparisonData({
          productionIds: [Number(this.state.productionId)],
          unit: null }, this.state.feeInclusion)
        .then((data) => {
          this.setState({
            seriesComparisonData: data
          })
        })
    } else {
      SeriesActionCreator.getSeriesComparisonData({
        productionIds: (this.state.selectedSeries3 && this.state.selectedSeries2)
          ? [Number(this.state.productionId), this.state.selectedSeries2, this.state.selectedSeries3]
          : (this.state.selectedSeries2)
            ? [Number(this.state.productionId), this.state.selectedSeries2]
            : [Number(this.state.productionId), this.state.selectedSeries3],
        unit: null
      }, this.state.feeInclusion)
      .then((data) => {
        this.setState({
          seriesComparisonData: data
        })
      })
    }
  }

  handleDnDTableAdd(bucket) {
    SeriesActionCreator.addDnDTableData(this.state.productionId, bucket)
      .then(() => {
        SeriesActionCreator.getDnDTableData(this.state.productionId,
          DateFormatter.formatDate(this.state.graphSettings.controlledDnDTableDate, DateFormatter.SERVER_API),
          this.state.feeInclusion);
        this.clearError();
      }, (error) => {
        this.setState({
          errorMessage: error.rawData
        })
      })
  }

  handleDnDTableDelete(id){
    SeriesActionCreator.deleteDnDTableData(this.state.productionId, id)
      .then(() => {
        SeriesActionCreator.getDnDTableData(this.state.productionId,
          DateFormatter.formatDate(this.state.graphSettings.controlledDnDTableDate,
            DateFormatter.SERVER_API),
          this.state.feeInclusion)
      })
  }

  handleDnDTableUpdate(id, bucket){
    console.log("SERIESDASHBOARD", id, bucket);
    SeriesActionCreator.updateDnDTableData(this.state.productionId, id, bucket)
      .then(() => {
        SeriesActionCreator.getDnDTableData(this.state.productionId,
          DateFormatter.formatDate(this.state.graphSettings.controlledDnDTableDate, DateFormatter.SERVER_API),
          this.state.feeInclusion);
        this.clearError();
      }, (error) => {
        console.log("INHERE");
        this.setState({
          errorMessage: error.rawData,
          errorBucketKey: id
        })
      })
  }

  handleSeriesChange(productionId) {
    this.setState({
      graphSettings: {
        controlledDnDTableDate: null,
        controlledEndDate: null,
        controlledStartDate: null,
        hasSalesData: null,
        hasTicketData: false,
        minDate: null,
        maxDate: null,
        selectedUnit: Constants.unit.day
      },
      selectedSeries2: null,
      selectedSeries3: null,
      showComparisonChart: false
    }, () => {
      SettingsActionCreator.saveProductionPreferences(productionId);
      this.props.getSeriesTicketInfo(productionId, this.state.feeInclusion);
    });
  }

  handleSubmitRevenueGoal(value) {
	  this.props.saveSeriesTicketRevenueGoal(this.state.productionId, value);
	  tracker.logEvent(this.props.summary.userId,this.props.summary.clientId,'save','goal',
      'ticketRevenue',parseFloat(value, 10));
  }

  handleSubmitTicketQuantityGoal(value) {
	  this.props.saveSeriesTicketQuantitySoldGoal(this.state.productionId, value);
	  tracker.logEvent(this.props.summary.userId,this.props.summary.clientId,'save','goal',
      'ticketQuantity',parseInt(value,10));
  }

  handleTabChanged(slideIndex) {
	  SettingsActionCreator.saveTabPreferences(slideIndex);
	  // log the GA event
	  if(slideIndex === 1) {
		  tracker.logEvent(this.props.summary.userId,this.props.summary.clientId,'toggle',
        'ticketBreakDown','ticketBreakDown',parseInt(slideIndex,10));
	  } else {
		  tracker.logEvent(this.props.summary.userId,this.props.summary.clientId,'toggle',
        'salesRevenue','salesRevenue',parseInt(slideIndex,10));
	  }
  }

	handleTooltip = (e) => { console.log('HANDLETOOLTIP');

		if ( IS_TABLET )  {
			let tooltip = this.refs.tooltip;
			console.log(tooltip);
			tooltip.onHover(e);
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
					this.handleTooltipBlur();
			}, 2400);
		}
	}

	handleTooltipBlur = (e) => { console.log('HANDLETTBLURRRR');
			this.setState({ tooltipIsActive: false}, () => {
				setTimeout(() => {
					this.setState({tooltipIsActive: true});
				}, 400);
			});
	}

	resetSeriesCompareField(series) {
    if (series === "SERIES2") {
      this.setState({
        selectedSeries2: null
      }, () => {this.handleSeriesCompare()}); //Callback for automatic refresh -- REMOVE IF USING COMPARE BUTTON
    } else if (series === "SERIES3") {
      this.setState({
        selectedSeries3: null
      }, () => {this.handleSeriesCompare()}); //Callback for automatic refresh -- REMOVE IF USING COMPARE BUTTON
    }
  }

	setControlledDates() {
		// console.log("SETTINGCONTROLLEDDATES");
		let { salesRevenueByDayData } = this.props;
		let { graphSettings } = this.state;

		if (salesRevenueByDayData) {
			let keys = Object.keys(salesRevenueByDayData);
			let startKey = keys.length <= 9 ?
				salesRevenueByDayData[0].label
				: salesRevenueByDayData[keys.length-10].label;

			this.setState({ graphSettings: {
					...graphSettings,
					controlledEndDate: DateFormatter.parse(salesRevenueByDayData[keys.length-1].label,
						DateFormatter.GRAPH_DISPLAY),
					controlledStartDate: DateFormatter.parse(startKey, DateFormatter.GRAPH_DISPLAY),
					initialEndDate: DateFormatter.parse(salesRevenueByDayData[keys.length-1].label, DateFormatter.GRAPH_DISPLAY),
					initialStartDate: DateFormatter.parse(startKey, DateFormatter.GRAPH_DISPLAY)
				}}, () => {
				if (this.state.graphSettings.controlledDnDTableDate === null)
					this.setControlledDnDDate(this.state.graphSettings.controlledEndDate);
			});
		}
	}

	setControlledDnDDate(date) {
		// console.log("SETTINGDNDDATE!!!");
		let { salesRevenueByDayData } = this.props;
		let { graphSettings } = this.state;

		if (salesRevenueByDayData) {
			let keys = Object.keys(salesRevenueByDayData);

			this.setState({ graphSettings: {
					...graphSettings,
					controlledDnDTableDate: DateFormatter.parse(date, DateFormatter.GRAPH_DISPLAY),
				}}, () => {
				SeriesActionCreator.getDnDTableData(this.state.productionId,
					DateFormatter.formatDate(this.state.graphSettings.controlledDnDTableDate, DateFormatter.SERVER_API),
					this.state.feeInclusion)
			});
		}
	}

	setDateRange(min) {
		// console.log("=========SETDATERANGE========", this.state.graphSettings);
		let { salesRevenueByDayData } = this.props;
		let { graphSettings } = this.state;
		let minDate = min ? min : this.state.graphSettings.minDate
		if (salesRevenueByDayData && minDate) {
			let keys = Object.keys(salesRevenueByDayData);
			this.setState({ graphSettings: {
					...graphSettings,
					minDate: min ? min : graphSettings.minDate,
					maxDate: DateFormatter.parse(salesRevenueByDayData[keys.length-1].label, DateFormatter.GRAPH_DISPLAY)
				}}, () => {
				// console.log("DATERANGECALLBACK1111111", graphSettings, this.state.graphSettings);
				// console.log("CALLBACK++++++++++++", this.state.graphSettings);
				if ( !graphSettings.controlledEndDate || !graphSettings.controlledStartDate ) this.setControlledDates();
			});
		}
	}

	toggleSeriesComparisonChart() {
    this.setState({
      showComparisonChart: true
    });
  }

  toggleFees() { console.log('TOGGLE FEES');
    let { feeInclusion } = this.state;
    this.setState({
      feeInclusion: {
        facilityFee : feeInclusion && !feeInclusion.facilityFee,
        convenienceFee : feeInclusion && !feeInclusion.convenienceFee
      }
    }, () => {
      this.props.getSeriesTicketInfo(this.state.productionId, this.state.feeInclusion);
      SeriesActionCreator.getProductionSummary(this.state.productionId, this.state.feeInclusion);
      this.handleSeriesCompare();
      SeriesActionCreator.getDnDTableData(this.state.productionId,
        DateFormatter.formatDate(this.state.graphSettings.controlledDnDTableDate, DateFormatter.SERVER_API),
        this.state.feeInclusion)
    });
  }

  updateGraphSettings(newValues) {
    let { graphSettings } = this.state;
    // console.log("newValues%%%%%", newValues);
    this.setState({graphSettings: {
      ...graphSettings,
      ...newValues
    }}, () => {
      // console.log("INSIDEUPDATECALLBACK######", this.state.graphSettings);
      // includes newValues in case state is still not updated
      if (
        (!graphSettings.controlledEndDate || newValues.controlledEndDate) &&
        (!graphSettings.controlledStartDate || newValues.controlledStartDate)) {
        this.setDateRange();
      }
      if ( !graphSettings.minDate && newValues.minDate) {
        this.setDateRange(newValues.minDate)
      }
      if (!graphSettings.controlledDnDTableDate && graphSettings.controlledEndDate) {
        this.setControlledDnDDate(graphSettings.controlledEndDate)
      }
      if (newValues.controlledDnDTableDate) this.setControlledDnDDate(newValues.controlledDnDTableDate)
      // add conditional for controlledTicketBreakdownDAte and call new function()
      // this.setTicketBreakdownDate()
    });
  }

  windowResize = () => {
    // console.log('windowResize landscape???', SeriesDashboardContainer.isTabletLandscape());
    this.setState({ media: {
        isSmall: SeriesDashboardContainer.isSmall(),
        isMedium: SeriesDashboardContainer.isMedium(),
        isMobileLandscape: SeriesDashboardContainer.isMobileLandscape(),
        isMonitor: SeriesDashboardContainer.isMonitor(),
        isTabletLandscape: SeriesDashboardContainer.isTabletLandscape(),
		    ...this.state.media,
    }});
  }

  render() {
    let { changeView, clientName, errorMessage, navBarClass, navBarOpen, salesRevenue,
          selectedView, summary, ticketQuantitySoldInitialValue, toggleNavBar  } = this.props;
    let { graphSettings, chartSize, comparisonChartSize, media:{isTablet, isTabletLandscape }, tooltipIsActive } = this.state;

    let selectSeriesLabels = {
      label: (this.state.media.isIOS10) ? "Name Series" : "Series name",
      error: "Production does not exist", placeholder: "Enter Series Name" };

    let seriesComparisonLabels = {
      series1Label: "With",
      series2Label: "And",
      error: "Production does not exist",
      placeholder: "Enter Series Name" };

    let openSeriesModal = !this.state.productionId && this.state.defaultProductionPreferenceLoaded;
    // console.log('isTablet, isTabletLandscape', isTablet, isTabletLandscape );
    return (
        <MuiThemeProvider muiTheme={theme}>
          <div id="SeriesDashboard" className={styles.seriesDashboard} >
	          { tooltipIsActive && <ReactHint ref="tooltip" /> }
	          {/*{ isTablet &&*/}
	          {/*<LandscapeMessage toggleMessage={isTabletLandscape} isPermanent />*/}
	          {/*}*/}

            <SeriesModal
              clientId={summary && summary.clientId}
              labels={selectSeriesLabels}
              onChange={this.handleSeriesChange}
              open={ openSeriesModal }
              productions={this.props.productions} />
            <PrintHeader
              selectedView={this.props.selectedView}
              tableDate={this.state.graphSettings.controlledDnDTableDate}
              productionName={summary && summary.productionName}
              reportPeriod={this.getReportPeriod()}
      		    unit={this.getSelectedUnit()} />

            <div onTouchStart={this.props.closeNavBar} className={styles.dashWrapper}>
              <div className={styles.viewWrapper}>
                <h6 className={styles.clientName}>{clientName}</h6>
                <header className={styles.header}>
                  <MenuBar
                    clientId={summary && summary.clientId}
                    hasTransactions={summary && summary.dateInfo.firstTransactionDate}
                    productionName={summary && summary.productionName}
                    productions={this.props.productions}
                    onChange={this.handleSeriesChange}
                    labels={selectSeriesLabels}
                    selectedView={this.props.selectedView}
                    toggleFees={this.toggleFees}
                    handleTooltip={this.handleTooltip}
                     />
                  { selectedView === Constants.view.main &&
                    <SeriesSummary
                      { ...summary }
                      handleTooltip={ this.handleTooltip }
                      salesRevenue={salesRevenue} />
                  }
                </header>
                <div
                  className={selectedView === Constants.view.table ? styles.dndTableMainWrapper : styles.mainWrapper}
                  ref="mainWrapper"
                >
                { selectedView === Constants.view.main &&
                  <div className={styles.mainWrapper}>
                    <section className={styles.graphContainer}>
                      <TabbedGraphContainer
                        className="tab-container"
                        chartSize={chartSize}
                        onRequestData={this.handleRequest}
                        onSettingChange={this.updateGraphSettings}
                        onTabChange={this.handleTabChanged}
                        printUnit={this.getSelectedUnit()}
                        salesRevenue={this.props.salesRevenue}
                        salesRevenueByDayData={this.props.salesRevenueByDayData}
                        salesRevenueGoal={parseInt(this.props.salesRevenueGoal, 10)}
                        selectedTabId={this.props.selectedTabId}
                        seriesSummary={summary}
                        settings={graphSettings}
                        ticketSalesByDayData={this.props.ticketSalesByDayData}
                        ticketTypes={this.props.ticketTypes} />
                    </section>
                    <section className={styles.asideContainer}>
                      <SalesRevenueGoal
                        goal={parseInt(this.props.salesRevenueGoal, 10)}
                        currency={true}
                        key="salesRevenueGoal"
                        value={this.props.salesRevenue}
                        productionId={ parseInt(this.state.productionId, 10) }
                        onSubmit={this.handleSubmitRevenueGoal}
                        title="Ticket Revenue Goal" />
                      <TicketQuantitySoldGoal
                        goal={parseInt(this.props.ticketQuantitySoldGoal,10)}
                        key="ticketQuantitySoldGoal"
                        value={ticketQuantitySoldInitialValue}
                        productionId={ parseInt(this.state.productionId, 10) }
                        onSubmit={this.handleSubmitTicketQuantityGoal}
                        title="Ticket Quantity Goal" />
                    </section>
                  </div>
                }
                { selectedView === Constants.view.comparison &&
                    <div className={styles.mainWrapper}>
                      <SeriesComparisonChart
                        ref="seriesComparison"
                        chartSize={comparisonChartSize}
                        changeSeries2={this.changeSeries2}
                        changeSeries3={this.changeSeries3}
                        clientId={summary && summary.clientId}
                        data={this.state.seriesComparisonData}
                        labels={seriesComparisonLabels}
                        productions={this.props.productions}
                        productionId={Number(this.props.productionId)}
                        productionName={summary && summary.productionName}
                        resetField={this.resetSeriesCompareField}
                        series1SalesRevenue={salesRevenue}
                        series1ticketsSold={summary && summary.totalTicketsSold}
                        selectedSeries2={this.state.selectedSeries2}
                        selectedSeries3={this.state.selectedSeries3}
                        showComparisonChart={this.state.showComparisonChart}
                        toggleSeriesComparisonChart={this.toggleSeriesComparisonChart} />
                    </div>
                }
                { selectedView === Constants.view.table &&
                    <div className={styles.dndTableMainWrapper}>
                      <TBContainer
                        clearError={this.clearError}
                        data={this.props.dndTableData}
                        errorBucketKey={this.state.errorBucketKey}
                        errorMessage={this.state.errorMessage}
                        hasSalesData={summary && summary.dateInfo.firstTransactionDate}
                        onBucketAdd={this.handleDnDTableAdd}
                        onBucketDelete={this.handleDnDTableDelete}
                        onBucketUpdate={this.handleDnDTableUpdate}
                        onSettingsChange={this.updateGraphSettings}
                        productionId={ parseInt(this.state.productionId, 10) }
                        settings={graphSettings} />
                    </div>
                }
                </div>
              </div>
              <PrintFooter />
            </div>
          </div>
        </MuiThemeProvider>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getProductionsList: () => {
      dispatch(SeriesActionCreator.loadProductionsList());
    },
    getSeriesTicketInfo: (id, feeInclusion) => {
      dispatch(SeriesActionCreator.getSeriesTicketInfo(id, feeInclusion));
    },
    // getTicketBreakdownInfo: (id? date? feeInclusion?) => {
    //   dispatch(SeriesActionCreator.getTicketBreakdownInfo(id, date, feeInclusion))
    // },
    saveSeriesTicketRevenueGoal: (id, value) => {
      dispatch(SeriesActionCreator.saveSeriesTicketRevenueGoal(id, value));
    },
    saveSeriesTicketQuantitySoldGoal: (id, value) => {
      dispatch(SeriesActionCreator.saveSeriesTicketQuantitySoldGoal(id, value));
    }
  }
}
const mapStateToProps = (state, ownProps) => {
  let error = state.ErrorReducer;
  let productionsStore = state.ProductionListReducer;
  let settingsStore = state.SettingsReducer;
  let summaryStore = state.ProductionSummaryReducer;
  let productions = summaryStore.productions;
  let productionId = settingsStore.selectedProductionId;
  let productionResult = productions ? productions[productionId] : null;
  // console.log("productionRESULT", productionResult);
  return {
    clientName : productionsStore.clientName,
    productions : productionsStore.productions,
    productionId: settingsStore.selectedProductionId, // not used
    selectedTabId: parseInt(settingsStore.selectedTabId, 10), // not used
    summary	:	productionResult ? productionResult.seriesSummary : null,
    salesRevenue: productionResult && productionResult.stats ? productionResult.stats.ticketRevenueTotal : null,
    salesRevenueGoal: productionResult && productionResult.goal ? productionResult.goal.ticketRevenueGoal : null,
    ticketQuantitySoldInitialValue: productionResult && productionResult.stats ? productionResult.stats.ticketQuantitySoldTotal : null,
    ticketQuantitySoldGoal: productionResult && productionResult.goal ? productionResult.goal.ticketQuantitySoldGoal : null,
    salesRevenueByDayData: productionResult ? productionResult.salesRevenue : null,
    ticketTypes: productionResult && productionResult.ticketBreakDown ? productionResult.ticketBreakDown.ticketTypes : null,
    ticketSalesByDayData: productionResult && productionResult.ticketBreakDown ? productionResult.ticketBreakDown.ticketsSoldByDay: null,
    errorMessage: error && error.error,
    feeInclusion: productionResult ? productionResult.feeInclusion : { facilityFee : false, convenienceFee : false },
    dndTableData: productionResult ? productionResult.dndTableData : null
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeriesDashboardContainer);



// WEBPACK FOOTER //
// ./src/scripts/components/series/SeriesDashboardContainer.js